import { render, staticRenderFns } from "./NoTenantSelectedMessage.vue?vue&type=template&id=33cf1a35&"
import script from "./NoTenantSelectedMessage.vue?vue&type=script&lang=ts&"
export * from "./NoTenantSelectedMessage.vue?vue&type=script&lang=ts&"
import style0 from "./NoTenantSelectedMessage.vue?vue&type=style&index=0&id=33cf1a35&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports